import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '../../../../Service/components/Dialog/Dialog';
import { useTheme } from '../../../../theme';
import { ButtonBase } from '@material-ui/core';
import { ArrowBack } from '../../../../Icons';
const FALLBACK_LANG = 'en';
const Rules = ({ rules, open, onClose }) => {
    const { t, i18n } = useTranslation('ServiceAggregation');
    const theme = useTheme('CheckoutAdditionalService').EveryPortLounge;
    const resultRules = React.useMemo(() => {
        if (!(rules === null || rules === void 0 ? void 0 : rules.length)) {
            return null;
        }
        let filteredRules = rules.filter(rule => rule.lang === (i18n === null || i18n === void 0 ? void 0 : i18n.language));
        if (!filteredRules.length) {
            filteredRules = rules.filter(rule => { var _a; return (_a = rule.lang === i18n.options.fallbackLng) !== null && _a !== void 0 ? _a : FALLBACK_LANG; });
        }
        return filteredRules.map(rule => rule.html).join('<br/>');
    }, [rules, i18n === null || i18n === void 0 ? void 0 : i18n.language]);
    const backButton = (onClose) => {
        return (React.createElement(ButtonBase, { onClick: onClose, className: theme.close }, ArrowBack));
    };
    return (React.createElement(Dialog, { isOpen: open, onClose: onClose, dialogType: "fullscreen", dialogHeader: t('Terms of use'), backButtonRender: backButton, content: React.createElement(React.Fragment, null,
            React.createElement("div", { className: theme.rules__content, dangerouslySetInnerHTML: { __html: resultRules } })) }));
};
export default Rules;
